export default "__VITE_ASSET__1NAFFAtZ__"